import axios from 'axios';
import { apiHost } from '../../../utils/apiHost';

// Bagian bersama halaman Pengaturan Absensi (server: controller/aturanAbsensiController.js).

export const base = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};
export const ambil = (url) => axios.get(url, { withCredentials: true }).then((r) => r.data);
export const kirim = (method, path, data) => axios({ method, url: `${base()}${path}`, data, withCredentials: true }).then((r) => r.data);
export const pesanGalat = (e) => e?.response?.data?.message || e?.message || 'Gagal';

/** Tambahkan ?cabang= (superadmin) ke alamat. */
export const denganCabang = (path, cabang, extra = {}) => {
  const q = new URLSearchParams({ ...extra, ...(cabang ? { cabang } : {}) }).toString();
  return `${base()}${path}${q ? `?${q}` : ''}`;
};

export const rupiah = (v) => `Rp ${Math.round(Number(v) || 0).toLocaleString('id-ID')}`;
export const ribuan = (s) => { const n = Number(String(s ?? '').replace(/[^0-9]/g, '')); return n ? n.toLocaleString('id-ID') : ''; };
export const angka = (s) => Number(String(s ?? '').replace(/[^0-9]/g, '')) || 0;

export const tglIso = (d) => { const p = (x) => String(x).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
export const tambahHari = (iso, n) => { const d = new Date(`${iso}T00:00:00`); d.setDate(d.getDate() + n); return tglIso(d); };
export const senin = (iso) => { const d = new Date(`${iso}T00:00:00`); const h = (d.getDay() + 6) % 7; d.setDate(d.getDate() - h); return tglIso(d); };
export const labelTgl = (iso, opsi = { weekday: 'short', day: 'numeric', month: 'short' }) => new Date(`${iso}T00:00:00`).toLocaleDateString('id-ID', opsi);
export const jam = (t) => (t ? String(t).slice(0, 5) : '-');

export const NAMA_HARI = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
export const URUT_HARI = [1, 2, 3, 4, 5, 6, 0]; // Senin dulu

export const WARNA_STATUS = {
  hadir: 'success', setengah: 'warning', izin: 'info', sakit: 'info', cuti: 'info', alfa: 'error',
  libur_nasional: 'secondary', libur: 'default', belum_pulang: 'warning', berlangsung: 'primary', belum_absen: 'default', tanpa_jadwal: 'default',
};
export const LABEL_STATUS = {
  hadir: 'Hadir', setengah: 'Setengah hari', izin: 'Izin', sakit: 'Sakit', cuti: 'Cuti', alfa: 'Alfa',
  libur_nasional: 'Libur nasional', libur: 'Libur', belum_pulang: 'Belum absen pulang', berlangsung: 'Sedang bekerja',
  belum_absen: 'Belum absen', tanpa_jadwal: 'Tanpa jadwal',
};
export const LABEL_PENGAJUAN = { izin: 'Izin', sakit: 'Sakit', cuti: 'Cuti' };
